import PropTypes from "prop-types";
import React, { Component } from "react";
import SubWizard from "../SubWizard";
import { withStyles } from "@material-ui/core";

const styles = () => ({
  stepContent: {
    padding: "0 20px 30px 20px"
  }
});

class StepContent extends Component {
  render() {
    const { step, activeSubStep, isValid } = this.props;
    const hasComponent = !!step.component.type;
    const StepComponent = step.component.type;
    const children = step.children ? step.children : [];
    return (
      this.props.active && (
        <React.Fragment>
          {hasComponent && <StepComponent step={step} isValid={isValid} />}

          {children.length > 0 && (
            <SubWizard
              isValid={isValid}
              activeStep={activeSubStep}
              steps={children}
            />
          )}
        </React.Fragment>
      )
    );
  }
}

StepContent.propTypes = {
  active: PropTypes.any,
  activeSubStep: PropTypes.any,
  isValid: PropTypes.any,
  step: PropTypes.shape({
    children: PropTypes.any,
    component: PropTypes.shape({
      type: PropTypes.any
    })
  })
};

export default withStyles(styles)(StepContent);
